import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemindersComponent } from './reminders.component';
import { RemindersListComponent } from './reminders-list/reminders-list.component';
import { ReminderFormComponent } from './reminder-form/reminder-form.component';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormModule, OverflowMenuModule, SharedModule } from 'components';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [RemindersComponent, RemindersListComponent, ReminderFormComponent],
  exports: [RemindersComponent],
  imports: [
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatFormFieldModule,
    OverflowMenuModule,
    FormModule,
    SharedModule
  ]
})
export class RemindersModule {}
